export function contractTableConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    searchShow: false,
    index: true,
    indexLabel: "序号",
    indexLabelWidth: 35,
    selection: true,
    selectionWidth:35,
    emitAddBtn: true,
    border:true,
    column: [{
        label: '保理合同',
        searchPlaceholder: "请输入保理合同",
        placeholder: '请输入保理合同',
        prop: "contractName",
        searchProp: 'contractName',
        searchkey: 'contractName',
        slot: true,
        search: true,
        overHidden: true,
        slotType: 'linkDetailUrl',
        width: '300',
        searchslot: true,
        bindLabel: 'contractName',
        searchKey: 'contractName',
        bindKey: 'id',
        dataUrl: 'bl/blcontractmanage/page',
        initParam: {
          nameSearch: 1
        },
      },
      {
        label: '合同状态',
        prop: 'dictContractState',
        span: 12,
        search: true,
        type: "select",
        dicUrl: "/api/blade-system/dict-biz/dictionary?code=bl_dict_contract_state",
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        dataType: 'number',
        rules: [{
          required: true,
          message: '请选择合同状态',
          // trigger: 'blur'
        }],
        width: '150',
      },
      {
        label: '审批状态',
        prop: "auditStatus",
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=project_build_state',
        props: {
        label: "dictValue",
        value: "dictKey"
        },      
        search: true,
        hide: true
    },
      {
        sortable: "custom",
        label: '项目编号',
        prop: "projectNumber",
        overHidden: true,
        width: "120",
      },
      {
        label: '项目名称',
        searchPlaceholder: "请输入项目名称",
        placeholder: '请输入项目名称',
        prop: "projectName",
        search: true,
        overHidden: true,
        width: '350'
      },
      {
        label: '日期范围',
        prop: 'timePic',
        type:'daterange',
        searchSpan:12,
        searchRange:true,
        search:true,
        hide:true
      }, 
      {
        label: "买方",
        prop: 'buyerCustName',
        width: '220',

      },
      {
        label: "卖方",
        prop: 'sellerCustName',
        width: '220',

      },
      {
        label: '保理商',
        prop: "formAccountingEntity",
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=bl_accounting_entity',
        dataType: 'number',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        width: '280',

      }, {
        label: "保理类型",
        prop: "projectType",
        type: "select",
        disabled: false,
        dataType: 'number',
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        width: '150',
      },
      {
        label: '合同金额（元）',
        prop: "factoringCredit",
        searchPlaceholder: "请输入合同金额",
        overHidden: true,
        sortable: "custom",
        width: 150,
        formatter: (row, value, label, column) => {
          return `${getMoney(Number(value))}`;
        },
      },
      {
        label: "内部收益率(%）",
        prop: "xirr",
        width: "120",
        formatter: (row, value, label, column) => {
          return value ? Number((value * 100)).toFixed(4) : ''
        },
        overHidden: true,

      },
      // {
      //   label: "签署时间",
      //   placeholder: "请选择时间",
      //   prop: "signDay",
      //   overHidden: true,
      //   width: "150"
      // },
      // {
      //   label: "是否变更",
      //   prop: "isMortgage",
      //   type: "radio",
      //   span: 12,
      //   width: 160,
      //   value: 0,
      //   dicData: [{
      //       label: "否",
      //       value: 0,
      //     },
      //     {
      //       label: "是",
      //       value: 1,
      //     },

      //   ],

      // },
      {
        label: '业务主办',
        width: "100",
        prop: "managerUserName",
        overHidden: true,
      }, {
        label: '业务协办',
        width: "100",
        prop: "assistUserName",
        overHidden: true,
      },
      {
        label: '所属部门',
        width: "100",
        prop: "managerDeptName",
        overHidden: true,
      },
      {
        label: "更新时间",
        type: "daterange",
        placeholder: "请选择时间",
        prop: "updateTime",
        overHidden: true,
        width: "150"
      },
      // {
      //   label: "审核状态",
      //   prop: "auditState",
      //   type: "select",
      //   disabled: false,
      //   dicUrl: '/api/blade-system/dict-biz/dictionary?code=audit_state',
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey"
      //   },
      //   hide: true,
      //   search: true
      // },
    ]
  }
}

export function surveyListConfig(getMoney) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    refreshBtn: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    index: true,
    indexLabel: "序号",
    // selection:true,
    // selectionWidth:45,
    column: [{
        label: '项目名称',
        searchPlaceholder: "请输入项目名称",
        placeholder: '请输入项目名称',
        prop: "name",
        // overHidden: true,
        width: '300'
      }, {
        sortable: "custom",
        label: '项目编号',
        prop: "number",
        overHidden: true,
        width: "120",
      },
      {
        label: '业务类型',
        prop: "status",
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=biz_type',
        dataType: 'number',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        search: true,

      },

      // {
      //   label: '保理类型',
      //   prop: "projectTypeStr",
      //   width	: '150'
      // },
      {
        label: '业务主办',
        width: "120",
        prop: "managerUserName",
        overHidden: true,
      }, {
        label: '业务协办',
        width: "120",
        prop: "assistUserName",
        overHidden: true,
      },
      {
        label: '保理商',
        prop: "accountingEntity",
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=bl_accounting_entity',
        dataType: 'number',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        width: '280',

      },
      // {
      //   label: '客户名称',
      //   prop: "sellerCustName",
      //   overHidden: true,
      //   width	: '200'      
      // },
      {
        sortable: "custom",
        label: '融资额度（元）',
        prop: "factoringCredit",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      },
      {

        label: '已申请合同金额（元）',
        prop: "contractSumAlready",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      },
      {

        label: '剩余可用额度',
        prop: "surplusQuota",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      },
      // {
      //   label: '业务经理',
      //   width: "120",
      //   prop: "managerUserName",
      //   overHidden: true,
      // },{
      //   label: '所属部门',
      //   width: "120",
      //   prop: "managerDeptName",
      //   overHidden: true,
      // },{
      //   label: '立项状态',
      //   prop: "projectStatus",
      //   type: "select",
      //   dicUrl: '/api/blade-system/dict-biz/dictionary?code=project_build_state',
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey"
      //   },
      //   search: true,
      //   hide: true
      // },
      // {
      //   label: '立项审批表',
      //   width: "120",
      //   prop: "managerUser",
      //   overHidden: true,
      // },
      // {
      //   label: '立项状态',
      //   width: "120",
      //   prop: "auditStatusStr",
      //   overHidden: true,
      // },
      // {
      //   label: '创建时间',
      //   width: "120",
      //   prop: "createTime",
      //   overHidden: true,
      // }      
    ]
  }
}

export function contractFilterConfig(selectDeptClick, selectPersonClick) {
  return {
    // labelWidth: 140,
    // emptyBtn: false,
    // submitBtn: false,    
    column: [{
        label: '项目名称',
        placeholder: '请输入项目名称',
        prop: "name"
      }, {
        label: '客户名称',
        placeholder: '请输入客户名称',
        prop: "sellerCustName"
      }, {
        label: '业务类型',
        prop: "factoringType",
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        search: true,
        hide: true
      },
      // {
      //   label: '保理商',
      //   prop: "factoringEntity",
      //   type: "select",
      //   dicUrl: '/api/blade-system/dict-biz/dictionary?code=rzzl_accounting_entity',
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey"
      //   },      
      //   search: true,
      //   hide: true
      // },
      {
        label: '业务经理',
        prop: 'managerUserName',
        click: () => {
          selectPersonClick();
        }
      }, {
        label: '所属部门',
        prop: 'managerDeptName',
        click: () => {
          selectDeptClick();
        }
      }, {
        label: '立项状态',
        prop: "auditStatus",
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=project_build_state',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        search: true,
        hide: true
      },
      // {
      //   label: '审核状态',
      //   prop: "auditStatus",
      //   type: "select",
      //   dicUrl: "/api/blade-system/dict-biz/dictionary?code=audit_state",
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey",
      //   },
      //   formatter: (row, value, label, column) => {
      //     return label ? label : "未提交";
      //   },
      //   dataType: "string",      
      //   search: true,
      //   hide: true
      // }
    ]
  }
}

export function contractAddFormConfig() {
  return {
    labelWidth: 130,
    emptyBtn: false,
    submitBtn: false,
    column: [{
        label: "卖方(债权人）",
        prop: "sellerCustName",
        // disabled: true,
        formslot: true,
        placeholder: "-",
        span: 12,
      }, {
        label: "买方(债务人)",
        prop: "buyerCustName",
        disabled: true,
        readonly: true,
        placeholder: "-",
        span: 12,
      },
      {
        label: "项目名称",
        prop: "projectName",
        disabled: true,
        readonly: true,
        placeholder: "-",
        span: 12,
      },
      {
        label: "项目名称(审批表)",
        prop: "projectName",
        disabled: true,
        readonly: true,
        placeholder: "-",
        span: 12,
      },
      {
        label: "项目编号",
        prop: "projectNumber",
        disabled: true,
        readonly: true,
        placeholder: "-",
        span: 12,
      },
      {
        label: "保理类型",
        prop: "projectType",
        type: "select",
        disabled: true,
        readonly: true,
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=foctoring_business_type',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        placeholder: "-",
        span: 12,
      },
      {
        label: "业务主办",
        prop: "managerUserName",
        disabled: true,
        placeholder: "-",
        span: 12,
      }, {
        label: "业务协办",
        prop: "assistUserName",
        disabled: true,
        placeholder: "-",
        span: 12,
      },
      {
        label: "项目来源",
        prop: "projectComeFrom",
        type: "select",
        disabled: true,
        readonly: true,
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=project_source',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        dataType: 'number',
        span: 12,
        placeholder: "-",
      },
      {
        label: "所属行业",
        prop: "industry",
        // type: "cascader",
        disabled: true,
        readonly: true,
        // dicUrl: "/api/blade-system/dict-biz/industryType",
        // props: {
        //   label: "dictValue",
        //   value: "dictKey",
        // },
        span: 12,
        placeholder: "-",
      },
      {
        label: '保理商',
        prop: "formAccountingEntity",
        type: "select",
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=bl_accounting_entity',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        span: 12,
        disabled: false,


      },
      {
        label: '授信是否可循环',
        prop: "isRevolvingCredit",
        type: "select",
        disabled: true,
        readonly: true,
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=factoring_loop_credit',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        span: 12,
        placeholder: "-",

      },
      {
        label: "合同金额",
        prop: "contractMoney",
        placeholder: "输入金额",
        span: 12,
        append: '元',
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],
      },
      {
        label: "起息日",
        prop: "rentDate",
        type: "date",
        format: "yyyy-MM-dd",
        valueFormat: "yyyy-MM-dd",
        span: 12,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],
      },
      {
        label: "报价方案",
        formslot: true,
        prop: "rentIdList",
        span: 24,
        rules: [{
          required: true,
          message: "请输入内容",
          trigger: "blur",
        }, ],
      }
      // {
      //   label: '是否使用集团授信',
      //   prop: "isGroupCredit",
      //   type: "select",
      //   disabled: false, 
      //   dicUrl: '/api/blade-system/dict-biz/dictionary?code=is_group_credit',
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey"
      //   },
      //   span: 12,
      //   dataType: 'number'
      // },


    ]
  }
}

export function mortgageTableFormConfig() {
  return {
    index: true,
    indexLabel: "序号",
    selection: true,
    selectionWidth: 45,
    column: [{
      label: '物品名称',
      prop: 'name'
    }, {
      label: '规格',
      prop: ''
    }, {
      label: '数量',
      prop: ''
    }, {
      label: '发票号',
      prop: ''
    }, {
      label: '购置时间',
      prop: ''
    }, {
      label: '生产厂商或供应商',
      prop: ''
    }, {
      label: '原值总价(含税)(元)',
      prop: ''
    }, {
      label: '原值总价(扣税)(元)',
      prop: ''
    }]
  }
}


export function tableInfoConfig(getMoney) {
  return {
    menuWidth: 100,
    menuIcon: false,
    detailBtn: false,
    editBtn: false,
    delBtn: true,
    detailAddBtn: false,
    addBtn: true,
    index: true,
    indexLabel: "批次",
    align: 'center',
    readonly: false,
    column: [{
        label: "卖方",
        prop: "sellerCustName",
        tableSlot:true,
        headerRequired:true
        // type: 'select',
        // bindLabel: "custName",
        // bindKey: "id",
        // methods: "get",
        // dataMethod: "params",
        // dataUrl:"bl/blreportstandard/relationCustId",
        // bindId: "sellerCustId",
        // headerRequired:true
      },
      {
        label: "买方",
        prop: "buyerCustName",
        type: 'input',
        disabled:false,
        placeholder:'输入内容',
        headerRequired:true
      },
      {
        label: "投放金额",
        prop: "splitInvestMoney",
        disabled:false,
        type: 'input',
        placeholder:'输入金额',
        headerRequired:true,
        append:'元'
      },  

    ],
  }
}
